@use "~theme/typography";

.reload {
  @include typography.body-link;
  @include typography.light-link;
  border: none;
  padding: 0;
}
